<template>
  <div>
    <div class="main-title marTop64">
      咨询分类
    </div>
    <div class="main-cates">
      <div class="block buy" zz-sortid="0" zz-sortname="买手机、数码" @click="enterPage('buy')" >
        <div class="title">买手机、数码</div>
        <div class="desc">官方验品质手机、平板等</div>
      </div>
      <div class="block sell" zz-sortid="1" zz-sortname="卖手机、数码" @click="enterPage('sell')">
        <div class="title">卖手机、数码</div>
        <div class="desc">平台回收</div>
      </div>
      <div class="block game" zz-sortid="2" zz-sortname="游戏账号"  @click="enterPage('game')">
        <div class="title">游戏账号</div>
        <div class="desc">游戏帐号、游戏租号</div>
      </div>
      <!-- <div class="block food" zz-sortid="3" zz-sortname="食品文玩潮物"  @click="enterPage('food')">
        <div class="title">食品文玩潮物</div>
        <div class="desc">临期食品</div>
      </div>
      <div class="block book" zz-sortid="4" zz-sortname="图书"  @click="enterPage('book')">
        <div class="title">图书</div>
        <div class="desc">收书、卖书</div>
      </div> -->
      <!-- <div v-if="isHLSOpen" class="block given" @click="enterPage('given')">
        <div class="title">欢乐送</div>
        <div class="desc">星星、免费领</div>
      </div> -->
       <div class="block personal" zz-sortid="5" zz-sortname="个人闲置"  @click="enterPage('personal')">
        <div class="title">个人闲置</div>
        <div class="desc">商品发布、交易纠纷</div>
      </div>
      <div class="block account" zz-sortid="6" zz-sortname="转转账号"  @click="enterPage('account')">
        <div class="title">转转账号</div>
        <div class="desc">转转账号登陆、申诉</div>
      </div>
      <div class="block activity" zz-sortid="7" zz-sortname="社群活动"  @click="enterPage('activity')">
        <div class="title">社群活动</div>
        <div class="desc">裂变活动、助力、群管理</div>
      </div>
    </div>

    <div v-show="isOverlayVisible" class="over-lap"></div>
    <kefu-opt-dialog
      v-show="isKefuOptDialogVisible"
      tel="4006018080"
      @consult="toConsult"
      @close="closeDialog"
    ></kefu-opt-dialog>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { login, queryParams, getCookie } from '../../../lib/utils'
import { hasArbitrationOrders, kefuChatValid } from '@api/resourceApi'

import KefuOptDialog from '../KefuOptDialog/KefuOptDialog'

const query = queryParams()

export default {
  name: 'QuestionCategory',
  data() {
    return {
      zzv: query.zzv || this.$route.query.zzv || getCookie('v'),
      //  电话客服
      hasArbitrationOrders: false,
      //  对话框
      isKefuOptDialogVisible: false,
      isHLSOpen: false,
      needValidChat: query.validChat || this.$route.query.validChat
    }
  },
  computed: {
    isOverlayVisible() {
      return this.isKefuOptDialogVisible || false
    }
  },
  methods: {
    validChatStatus() {
      if (+this.needValidChat !== 1) return
      kefuChatValid({
        uid: getCookie('uid')
      }).then(resp => {
        const { url, status } = resp
        if (status && +status === 0) {
          native.skipToUrl({
            targetUrl: url
          })
        }
      })
    },
    enterPage(name) {
      lego.send({
        pagetype: 'ZZUP_HELPCENTER',
        actiontype: 'ENTRY_CLICK',
        backup: {
          name
        }
      })

      let url = ''

      // 启首页--转转客服入口增加needHideHead参数
      if (name === 'buy') {
        url = 'https://feentry.zhuanzhuan.com/athena?clientid=zzcs_3c&needHideHead=3'
      } else if (name === 'sell') {
        url = 'https://feentry.zhuanzhuan.com/athena?clientid=zzcs_recycle&needHideHead=3'
      } else if (name === 'game') {
        url = 'https://feentry.zhuanzhuan.com/athena?clientid=zzcs_game&needHideHead=3'
      } else if (name === 'food') {
        url = 'https://feentry.zhuanzhuan.com/athena?clientid=zzcs_food_ornaments&needHideHead=3'
      } else if (name === 'book') {
        url = 'https://feentry.zhuanzhuan.com/kefuzhognxin_app?clientid=zzcs_book&needHideHead=3'
      } else if (name === 'personal') {
        url = 'https://feentry.zhuanzhuan.com/kefuzhognxin_app?clientid=zzcs_c2c&needHideHead=3'
      } else if (name === 'account') {
        url = 'https://feentry.zhuanzhuan.com/kefuzhognxin_app?clientid=zzcs_account&needHideHead=3'
      // } else if (name === 'verdict') {
      //   if (this.hasArbitrationOrders) {
      //     this.isKefuOptDialogVisible = true
      //     return
      //   }
      //   url = 'https://feentry.zhuanzhuan.com/kefuzhognxin_app?clientid=kefuzhognxin_pingtaijieru'
      } else if (name === 'activity') {
        url = 'https://feentry.zhuanzhuan.com/athena?clientid=zzcs_wechat'
      }

      native.skipToUrl({
        targetUrl: url
      })
    },
    toConsult() {
      this.isKefuOptDialogVisible = false

      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?skillId=10010'
      })
    },
    closeDialog() {
      this.isKefuOptDialogVisible = false
    }
  },
  created() {
    const vers = this.zzv && this.zzv.split('.').map((e) => Number(e))
    this.isHLSOpen = false
    if (
      vers &&
        ((vers[0] === 5 && vers[1] === 8 && vers[2] >= 5) ||
          (vers[0] === 5 && vers[1] >= 9) ||
          vers[0] >= 6)
    ) {
      this.isHLSOpen = true
    }

    login()
      .then(() => {
        console.info('登录成功. uid: ', getCookie('uid'))
        this.validChatStatus()
        return hasArbitrationOrders()
      })
      .then((res) => {
        console.info(res)
        this.hasArbitrationOrders = res.hasArbitrationOrders
      })
  },
  components: {
    KefuOptDialog
  }
}
</script>

<style lang="less" scoped>
  @import 'QuestionCategory.less';
  @import '../HelpCenter.less';
</style>
